export class TransactionOptionsModel {
    storeName: string;
    dbMode: any;
    error: Function;
    completed: Function;
    abort?: Function;
}

export class TableLotteryModel {
    lotteryCode: string;
    lotteryDetail: string;
    constructor(lotteryCode: string, lotteryDetail?: string) {
        this.lotteryCode = lotteryCode;
        this.lotteryDetail = lotteryDetail;
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/models/indexdb.model.ts